module.exports = __webpack_public_path__ + "img/marketMainLogo.a3dd5f43.png";